<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
          <h3 style="font-size: 90px">河南善信医养科技有限公司</h3>
          <p>Henan Shanxin Medical & Foster Technology Co., Ltd.</p>
        </div>
        <p class="slogan">让所有老人晚年都有尊严的幸福生活</p>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>经典案例</h3>
          <p>Suecessful Cass</p>
        </div>
        <ul class="case-item">
          <li v-for="(item, index) in caseList" :key="index">
            <img :src="item" />
          </li>
        </ul>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in newsList" :key="i">
            <div :style="'order: ' + (i % 2 == 0 ? 1 : 3)">
              <div class="item-img">
                <img :src="news.Img" alt="" />
              </div>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: ' + (i % 2 == 0 ? 3 : 1)">
              <h3>{{ news.Title }}</h3>
              <p>{{ news.Content }}</p>
              <span>{{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",

  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      loading: false,
      caseList: [
        require("../assets/img/Goin_1.jpg"),
        require("../assets/img/Goin_2.jpg"),
        require("../assets/img/Goin_3.jpg"),
        require("../assets/img/Goin_4.jpg"),
        require("../assets/img/Goin_5.jpg"),
        require("../assets/img/Goin_6.jpg"),
      ],
      newsList: [
        {
          Id: "1",
          Title: "智慧养老有哪些发展机会？两会代表给出建议...",
          Img: require("../assets/img/new_1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "智慧养老是指利用信息技术对养老赋能，帮助老年人过上有价值、有意义的幸福生活，包括可穿戴设备、康复辅助器具等产品，涉及生活照料、医疗护理、上门服务等多方面。智慧养老支撑中国的老人正在由生存型养老向品质型养老迈进。“传统养老模式已不能满足当前及未来的养老需求。”全国政协委员、武汉大学土木建筑工程学院教授徐礼华表示，在对社区硬件设施进行适老化系统改造的同时，应调整优化养老服务的智能化水平，构建城镇适老化社区智能化康养服务平台，让更多老年人实现居家康养生活。徐礼华委员建议，鼓励社会资本参与构建智能化康养服务平台，利用物联网等新一代信息技术产品，实现个人、家庭、社区、机构与健康养老资源的有效对接和优化配置。积极发挥院校培养人才的渠道作用，建立企业和从业人员的资质认证制度，助推智慧养老工作走上专业化、规范化、职业化的良性发展道路。",
        },
        {
          Id: "2",
          Title: "看懂智慧养老",
          Img: require("../assets/img/new_2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "2024年开年，首场国务院常务会议就聚焦老年人群，研究发展银发经济、增进老年人福祉的政策举措。1月15日，国务院办公厅印发《关于发展银发经济增进老年人福祉的意见》，提出4个方面26项举措。这是我国首个以“银发经济”命名的政策文件。未来，国家将着力培育高精尖产品和高品质服务模式，让老年人共享发展成果，安享幸福晚年。银发经济覆盖面广，但现阶段相关产业主要集中在餐饮、护理、保健等基础养老服务方面。而老年人多元化、差异化、个性化的需求，正变得越来越旺盛和迫切，却尚未得到有效满足，这其中蕴含着巨大的发展机遇。老龄产业将迎来更多创新与融合发展的机遇。作为智慧养老服务平台，我们期望的是“融合创新 智慧养老”。随着科技进步和跨界合作的深化，养老服务将更加智慧化、个性化，满足老年人多元化需求。我们致力于推动政策、资源、技术等多方力量融合，希望能打破传统边界，实现跨界融合，共同开创老龄产业的美好未来。通过科技助力、服务升级，让老年人享受更加幸福、健康的晚年生活。",
        },
        {
          Id: "3",
          Title: "告别实体店...全新智慧养老成为主流",
          Img: require("../assets/img/new_3.png"),
          CreateTime: " 2024-06-07 15:44s",
          Content:
            "在数字化浪潮的冲击下，许多实体店正面临着前所未有的挑战，亏损现象屡见不鲜。然而，正是这样的时代背景下，居家养老产业却展现出了巨大的发展潜力和广阔的市场前景。中国作为人口大国，老龄化问题尤为突出，如何为老年人提供高品质、个性化的养老服务，确保他们安享晚年，成为社会关注的焦点。传统的家庭养老和机构养老已不能满足日益增长的需求，而智慧居家养老的兴起，为解决老龄化问题提供了新的解决方案。 市场竞争加剧：随着互联网电商的快速发展，消费者购物渠道日益多样化，实体店面临着来自线上平台的激烈竞争。成本压力大：实体店需要承担高昂的租金、人力成本等费用，而在利润空间有限的情况下，这些成本压力无疑加剧了亏损的风险。消费者行为转变：随着年轻消费群体的崛起，他们的消费习 惯和购物需求发生了显著变化，更注重个性化、便捷化和体验化。这使得传统实体店在吸引年轻消费者方面面临挑战。市场需求旺盛：随着社会老龄化的加速推进，居家养老成为越来越多老年人的首选。他们对居家养老服务的需求日益增长，为产业发展提供了广阔的市场空间。政策支持力度加大：为应对老龄化挑战，政府出台了一系列政策措施，鼓励和支持居家养老产业的发展。这些政策为居家养老服务机构提供了更多的发展机会和优惠政策。创新服务模式不断涌现：随着科技的进步，越来越多的创新服务模式应用于居家养老领域，如智能养老设备、远程医疗服务等。这些创新服务模式不仅提升了服务质量，也满足了老年人的多样化需求。  ",
        },
      ],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
    };
  },

  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  created() {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    // overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 80px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url("https://upload.shanxinyy.com/homepage/jinrongdashaBj.jpg")
    no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>
